export function CreateStationCTA() {
	return (
		<div className="pt-16 text-center">
			<h3 className="text-2xl md:text-3xl font-serif-600 mb-4">
				How to Create Your Own Station
			</h3>
			<p className="text-base md:text-lg leading-relaxed font-serif text-gray-600 max-w-md mx-auto mb-6">
				Download <a href="https://apps.apple.com/app/apple-store/id6746954963?pt=123127751&ct=macrowave.co&mt=8" class="underline">Macrowave</a>, click On Air, and share your station link. Start broadcasting in minutes with no technical setup required.
			</p>
			<a
				href="/blog/how-to-start"
				className="inline-block px-6 py-3 bg-black text-white font-serif font-semibold rounded-lg hover:bg-gray-800 transition-colors"
			>
				Learn More
			</a>
		</div>
	);
}
